<script setup lang="ts">
import { computed, ref } from 'vue'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/tooltip'
import { FEEDBACK_CONFIRMATION_DURATION_MS } from './feedback_buttons'

const props = defineProps<{
  tooltipHoverText: string
  iconName: string
  isActive: boolean
}>()

const emit = defineEmits<{
  updated: []
}>()

const FEEDBACK_SUBMITTED_TEXT = 'Feedback submitted'

const isShowingConfirmation = ref(false)
let confirmationTimeout: ReturnType<typeof setTimeout> | undefined

const tooltipText = computed(() => (isShowingConfirmation.value ? FEEDBACK_SUBMITTED_TEXT : props.tooltipHoverText))
const iconClass = computed(() => (props.isActive ? 'material-icons' : 'material-icons-outlined'))

function showConfirmation() {
  isShowingConfirmation.value = true
  clearTimeout(confirmationTimeout)
  confirmationTimeout = setTimeout(() => {
    isShowingConfirmation.value = false
  }, FEEDBACK_CONFIRMATION_DURATION_MS)
}

function hideConfirmation() {
  clearTimeout(confirmationTimeout)
  isShowingConfirmation.value = false
}

function handleClick() {
  const isSelecting = !props.isActive
  emit('updated')
  if (isSelecting) {
    showConfirmation()
    return
  }
  hideConfirmation()
}
</script>

<template>
  <TooltipProvider :delay-duration="0">
    <Tooltip>
      <TooltipTrigger as-child>
        <button
          type="button"
          class="group mx-1 rounded-full leading-none focus:outline focus:outline-1 focus:outline-offset-2 focus:outline-gray-900"
          :aria-label="tooltipHoverText"
          :aria-pressed="isActive"
          :data-testid="`feedback-button-${iconName}`"
          @click="handleClick"
        >
          <span :class="iconClass" class="block w-6 rounded-full p-1 text-lg group-hover:bg-gray-200 group-focus:bg-gray-200" :data-feedback-type="iconName" aria-hidden="true">{{ iconName }}</span>
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom">
        <p>{{ tooltipText }}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
